@let hidden = isHidden();

<div class="flex gap-2 justify-end pr-[0.25em]">
  <app-pan-button
    panRole
    [roles]="['admin', 'branch-manager', 'branch-owner', 'market-manager']"
    [color]="hidden ? 'default' : 'warning'"
    [state]="isTogglingVisibility() ? 'loading' : 'default'"
    [width]="80"
    matTooltip="Hide/Unhide incident from guest portal"
    fill="outline"
    (click)="toggleIncidentVisibility()"
  >
    {{ hidden ? "Unhide" : "Hide" }}
  </app-pan-button>

  <app-pan-button
    color="info"
    icon="visibility"
    matTooltip="Findings Summary"
    fill="outline"
    data-testid="findings-summary-button"
    (click)="params.findingsCallback(params.data)"
    appTrackReviewActivity
    [appTrackReviewActivity]="params.data.review_id"
    [appTrackReviewActivityAccessType]="'case'"
    [appTrackReviewActivityValue]="'comments'"
  ></app-pan-button>

  <a panButton [routerLink]="['/shared', 'investigation', params.data.review_id]" target="_blank" color="info" icon="open_in_new" matTooltip="View Details"></a>
</div>
